import React, {useEffect, useState, useMemo, useCallback, useRef} from 'react';
import TableGrid from "../../../components/Table/TableGrid";
import {apiGet, apiPost} from "../../../services/apiClient";
import {Form, Grid as GridView, Input} from "semantic-ui-react";
import ButtonCargo from "../form_v3/buttons/buttonCargo";
import ButtonDocs from "../form_v3/buttons/buttonDocs";
import Dropdown from "../../../components/Dropdown";
import RangeDatePicker from "../../../components/DatePicker/RangeDatePicker";
import StateDropdown from "../../../components/Dropdowns/StateDropdown";
import InputDropdown from "../../../components/Dropdowns/InputDropdown";
import {dateToFilterFormat} from "../../../services/date";
import qs from 'query-string';
import {getCurrentUserId} from "../../../services/userRights";

const FiltersBlock = ({filters, mergedFilters, updateFilter, clearSettings, isBusy, getSafeDateValue}) => {
    const [statuses, setStatuses] = useState([]);
    const [carriers, setCarriers] = useState([]);
    const massUploadFilterSource = mergedFilters || filters;
    const activeMassUploadIds = Array.isArray(massUploadFilterSource.massUploadFileId)
        ? massUploadFilterSource.massUploadFileId.filter(Boolean)
        : (massUploadFilterSource.massUploadFileId ? [massUploadFilterSource.massUploadFileId] : []);
    const activeMassUploadLabel = activeMassUploadIds.length > 0
        ? `Список МЗ № ${activeMassUploadIds.join(', ')}`
        : null;

    const getStatuses = () => apiGet('parcels/status/all')
        .then(data => {
            setStatuses((data.entries || []).map(s => ({
                key: s.id,
                value: s.id,
                text: s.name,
                code: s.code
            })))
        })
        .catch(e => console.error(e));

    const getCarriers = () => apiPost('parcels/list/author/ref/carriers', {})
        .then(data => {
            setCarriers((data.entries || []).map(s => ({
                key: s.id,
                value: s.id,
                text: s.name,
            })))
        })
        .catch(e => console.error(e));

    useEffect(() => {
        let isMounted = true;
        
        const loadData = () => {
            apiGet('parcels/status/all')
                .then(statusData => {
                    if (isMounted) {
                        setStatuses((statusData.entries || []).map(s => ({
                            key: s.id,
                            value: s.id,
                            text: s.name,
                            code: s.code
                        })));
                    }
                })
                .catch(e => console.error(e));
                
            apiPost('parcels/list/author/ref/carriers', {})
                .then(carriersData => {
                    if (isMounted) {
                        setCarriers((carriersData.entries || []).map(s => ({
                            key: s.id,
                            value: s.id,
                            text: s.name,
                        })));
                    }
                })
                .catch(e => console.error(e));
        };
        
        loadData();
        
        return () => {
            isMounted = false;
        };
    }, []);

    const setTypeFilter = (name, type) => {
        let filter = filters[name] || [];
        filter.includes(type) ? filter = filter.filter(f => f !== type) : filter.push(type);
        updateFilter(name, filter)
    }

    return <section className='filters-block sizes-block'>
        <GridView>
            <GridView.Row>
                <GridView.Column>
                    <Form.Field>
                        <label>
                            Тип отправления
                        </label>
                        <div className='types-btns'>
                            <ButtonCargo
                                isSelected={(filters.parcelType || []).includes('2')}
                                onClick={() => setTypeFilter('parcelType', '2')}
                            />
                            <ButtonDocs
                                isSelected={(filters.parcelType || []).includes('1')}
                                onClick={() => setTypeFilter('parcelType', '1')}
                            />
                        </div>
                    </Form.Field>
                </GridView.Column>
                <GridView.Column>
                    <GridView>
                        <GridView.Row columns={16}>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input ultra-compact'>
                                    <label>
                                        Город и адрес отправки
                                    </label>
                                    <InputDropdown
                                        placeholder={'Введите город или адрес отправки'}
                                        name={'fullName'}
                                        url={'parcels/addresses/suggestions'}
                                        value={filters.shipmentAddress || ''}
                                        onChange={(name, value) => {
                                            updateFilter('shipmentAddress', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Отправитель
                                    </label>
                                    <Input
                                        placeholder={'Введите юр. название или контактное лицо'}
                                        fluid
                                        value={filters.senderFullName || ''}
                                        onChange={(e, {value}) => {
                                            updateFilter('senderFullName', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={3}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Перевозчик
                                    </label>
                                    <Dropdown
                                        name="carrier"
                                        search={false}
                                        multiple
                                        compact
                                        options={carriers}
                                        value={filters.carrier || []}
                                        onChange={(e, {value}) => updateFilter('carrier', value)}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={3}/>
                        </GridView.Row>
                    </GridView>
                </GridView.Column>
            </GridView.Row>
            <GridView.Row>
                <GridView.Column>
                    <Form.Field>
                        <div className='types-btns'>
                            <Form.Field className='filter-input'>
                                <RangeDatePicker
                                    compact
                                    label={"Даты отгрузки"}
                                    dateFromName="from"
                                    dateFromValue={getSafeDateValue(filters.departureDateFrom)}
                                    dateToName="to"
                                    dateToValue={getSafeDateValue(filters.departureDateTo)}
                                    onChange={(d) => {
                                        updateFilter('departureDateFrom', d.from);
                                        updateFilter('departureDateTo', d.to);
                                    }}
                                    pattern='dd.MM.yyyy'
                                />
                            </Form.Field>
                            <Form.Field className='filter-input'>
                                <RangeDatePicker
                                    compact
                                    label={"Даты доставки"}
                                    dateFromName="from"
                                    dateFromValue={getSafeDateValue(filters.deliveryDateFrom)}
                                    dateToName="to"
                                    dateToValue={getSafeDateValue(filters.deliveryDateTo)}
                                    onChange={(d) => {
                                        updateFilter('deliveryDateFrom', d.from);
                                        updateFilter('deliveryDateTo', d.to);
                                    }}
                                    pattern='dd.MM.yyyy'
                                />
                            </Form.Field>
                        </div>
                    </Form.Field>
                </GridView.Column>
                <GridView.Column>
                    <GridView>
                        <GridView.Row columns={16}>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input ultra-compact'>
                                    <label>
                                        Город и адрес доставки
                                    </label>
                                    <InputDropdown
                                        placeholder={'Введите город или адрес доставки'}
                                        name={'fullName'}
                                        url={'parcels/addresses/suggestions'}
                                        value={filters.deliveryAddress || ''}
                                        onChange={(name, value) => {
                                            updateFilter('deliveryAddress', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={5}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Получатель
                                    </label>
                                    <Input
                                        placeholder={'Введите юр. название или контактное лицо'}
                                        fluid
                                        value={filters.recipientFullName || ''}
                                        onChange={(e, {value}) => {
                                            updateFilter('recipientFullName', value)
                                        }}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column width={3}>
                                <Form.Field className='filter-input'>
                                    <label>
                                        Статус перевозки
                                    </label>
                                    <StateDropdown
                                        compact
                                        options={statuses}
                                        value={filters.status || []}
                                        onChange={(e, {value}) => updateFilter('status', value)}
                                    />
                                </Form.Field>
                            </GridView.Column>
                            <GridView.Column className={'filters-btn'} width={3} textAlign='center'>
                                {activeMassUploadLabel && (
                                    <div style={{
                                        marginBottom: '8px',
                                        color: '#135CA9',
                                        fontSize: '13px',
                                        fontWeight: 500
                                    }}>
                                        {activeMassUploadLabel}
                                    </div>
                                )}
                                <div
                                    onClick={() => !isBusy && clearSettings()}
                                    className='total__change-btn_name'
                                >
                                    Сбросить фильтры
                                </div>
                            </GridView.Column>

                        </GridView.Row>
                    </GridView>
                </GridView.Column>
            </GridView.Row>
        </GridView>
    </section>
}

const FiltersAndTable = ({disableFilters, isBusy, onFiltersChange, loadData, gridKey, columns, summaries, selectedIds, setAll, setSelected, searchId, setSearchId, setSettings, filtersWidth, isFixed}) => {
    const rowCount = 50;
    
    // Функция для безопасного получения значения даты
    const getSafeDateValue = (value) => {
        if (!value) return null;
        try {
            const date = new Date(value);
            if (isNaN(date.getTime())) {
                console.warn('Некорректное значение даты:', value);
                return null;
            }
            // Возвращаем объект Date, а не строку
            return date;
        } catch (e) {
            console.warn('Ошибка при парсинге даты:', value, e);
            return null;
        }
    };
    
    // Функции для работы с localStorage и URL-параметрами
    const getUserId = () => {
        try {
            return getCurrentUserId() || 'anonymous';
        } catch (e) {
            console.warn('Ошибка при получении ID пользователя:', e);
            return 'anonymous';
        }
    };

    const getStorageKey = () => `filtersAndTable_${gridKey}_${getUserId()}_filters`;
    const getOrderStorageKey = () => `filtersAndTable_${gridKey}_${getUserId()}_order`;
    const getSearchStorageKey = () => `filtersAndTable_${gridKey}_${getUserId()}_search`;
    
    const isValidDate = (date) => {
        if (!date) return true; // null/undefined допустимы
        try {
            const parsedDate = new Date(date);
            return !isNaN(parsedDate.getTime());
        } catch (e) {
            return false;
        }
    };
    
    const cleanDateFilters = (filters) => {
        const dateFields = ['departureDateFrom', 'departureDateTo', 'deliveryDateFrom', 'deliveryDateTo', 'createdDateFrom', 'createdDateTo'];
        const cleanedFilters = { ...filters };
        
        dateFields.forEach(field => {
            if (cleanedFilters[field] && !isValidDate(cleanedFilters[field])) {
                console.warn(`Некорректная дата в localStorage для поля ${field}:`, cleanedFilters[field]);
                delete cleanedFilters[field];
            }
        });
        
        return cleanedFilters;
    };
    
    const loadFromLocalStorage = () => {
        try {
            const savedFilters = localStorage.getItem(getStorageKey());
            const savedOrder = localStorage.getItem(getOrderStorageKey());
            const savedSearch = localStorage.getItem(getSearchStorageKey());
            const filters = savedFilters ? JSON.parse(savedFilters) : {};
            
            return {
                filters: cleanDateFilters(filters),
                order: savedOrder ? JSON.parse(savedOrder) : null,
                searchId: savedSearch || ''
            };
        } catch (e) {
            console.warn('Ошибка при загрузке фильтров из localStorage:', e);
            return { filters: {}, order: null, searchId: '' };
        }
    };
    
    const saveToLocalStorage = (filters, order, searchId) => {
        try {
            // Очищаем некорректные даты перед сохранением
            const cleanedFilters = cleanDateFilters(filters);
            localStorage.setItem(getStorageKey(), JSON.stringify(cleanedFilters));
            if (order) {
                localStorage.setItem(getOrderStorageKey(), JSON.stringify(order));
            } else {
                localStorage.removeItem(getOrderStorageKey());
            }
            if (searchId && searchId.trim()) {
                localStorage.setItem(getSearchStorageKey(), searchId.trim());
            } else {
                localStorage.removeItem(getSearchStorageKey());
            }
        } catch (e) {
            console.warn('Ошибка при сохранении фильтров в localStorage:', e);
        }
    };
    
    const loadFromUrl = () => {
        try {
            const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
            const filters = params.filters ? JSON.parse(decodeURIComponent(params.filters)) : {};
            const order = params.order ? JSON.parse(decodeURIComponent(params.order)) : null;
            const searchId = params.search ? decodeURIComponent(params.search) : '';
            
            return {
                filters: cleanDateFilters(filters),
                order: order,
                searchId: searchId
            };
        } catch (e) {
            console.warn('Ошибка при загрузке фильтров из URL:', e);
            return { filters: {}, order: null, searchId: '' };
        }
    };

    const hasMassUploadFileIdFilter = (sourceFilters) => {
        if (!sourceFilters || sourceFilters.massUploadFileId == null) {
            return false;
        }
        if (Array.isArray(sourceFilters.massUploadFileId)) {
            return sourceFilters.massUploadFileId.filter(Boolean).length > 0;
        }
        return String(sourceFilters.massUploadFileId).trim().length > 0;
    };

    // Явный massUploadFileId в URL: сбрасываем прочие фильтры и сохраняем только его
    // (как обычный фильтр — при следующем заходе без URL подтянется из localStorage)
    const getInitialState = () => {
        const urlData = loadFromUrl();
        const localData = loadFromLocalStorage();

        if (hasMassUploadFileIdFilter(urlData.filters)) {
            const massUploadOnlyFilters = {
                massUploadFileId: urlData.filters.massUploadFileId
            };
            saveToLocalStorage(massUploadOnlyFilters, null, '');
            return {
                urlState: { filters: {}, order: null, searchId: '' },
                filters: massUploadOnlyFilters,
                order: null,
                clearSearch: true,
                clearUrlAfterMassUpload: true
            };
        }

        return {
            urlState: urlData,
            filters: localData.filters,
            order: localData.order,
            clearSearch: false,
            clearUrlAfterMassUpload: false
        };
    };

    const [initialState] = useState(getInitialState);
    const [urlState, setUrlState] = useState(initialState.urlState);
    const [filters, setFilters] = useState(initialState.filters);
    const [order, setOrder] = useState(initialState.order);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [page, setPageState] = useState(1);
    const searchAbortControllerRef = useRef(null);
    const isMountedRef = useRef(true);
    
    const setPage = (newPage) => {
        setPageState(newPage);
    };
    const [totalCount, setTotalCount] = useState(0);

    const dateFilter = (name, sourceFilters, filtersArray) => {
        // Для createdDate сохраняем время, для других дат используем стандартное форматирование
        const isCreatedDate = name === 'createdDate';
        
        const formatDate = (dateValue) => {
            if (!dateValue) return null;
            if (isCreatedDate) {
                // Для createdDate сохраняем полную дату и время в формате MySQL (YYYY-MM-DD HH:mm:ss)
                const date = new Date(dateValue);
                if (isNaN(date.getTime())) return null;
                
                // Если уже в формате MySQL (YYYY-MM-DD HH:mm:ss), возвращаем как есть
                if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateValue)) {
                    return dateValue;
                }
                
                // Иначе форматируем в MySQL формат
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } else {
                // Для других дат используем стандартное форматирование (без времени)
                return dateToFilterFormat(dateValue);
            }
        };
        
        const date = formatDate(sourceFilters[name]);
        const from = formatDate(sourceFilters[`${name}From`]);
        const to = formatDate(sourceFilters[`${name}To`]);

        let operation;
        if (date) operation = 'equals'
        else {
            if (from && to) operation = 'between'
            else if (from) operation = 'greater-equal'
            else operation = 'less-equal'
        }

        (date || from || to) && filtersArray.push({
            fieldName: name,
            operation,
            value: (date || [from, to]).toString()
        })
    }

    const getMergedFiltersForRequest = useCallback(() => {
        return {
            ...(urlState.filters || {}),
            ...(filters || {})
        };
    }, [urlState.filters, filters]);

    const getMergedSearchForRequest = useCallback(() => {
        const externalSearch = (urlState.searchId || '').trim();
        const internalSearch = (searchId || '').trim();

        if (externalSearch && internalSearch) {
            return `${externalSearch} ${internalSearch}`.trim();
        }

        return externalSearch || internalSearch || '';
    }, [urlState.searchId, searchId]);

    const getSettings = useCallback(() => {
        const mergedFilters = getMergedFiltersForRequest();
        const mergedSearchId = getMergedSearchForRequest();
        let filtersArray = [];
        
        // Обрабатываем только непустые фильтры
        Object.keys(mergedFilters).forEach(fName => {
            const filterValue = mergedFilters[fName];
            if (!fName.includes('Date') && filterValue && 
                (Array.isArray(filterValue) ? filterValue.length > 0 : filterValue.toString().trim().length > 0)) {
                filtersArray.push({
                    fieldName: fName,
                    operation: Array.isArray(filterValue) ? 'in' : 'contains',
                    value: filterValue.toString()
                });
            }
        });

        // Добавляем поиск только если есть текст (несколько идентификаторов через пробел, как в «Моих отчётах»)
        if (mergedSearchId && mergedSearchId.length > 0) {
            const ids = mergedSearchId.split(/\s+/).map(s => s.trim()).filter(Boolean);
            filtersArray.push({
                fieldName: 'anyNumber',
                operation: ids.length > 1 ? 'in' : 'contains',
                value: ids.length > 1 ? ids.join(',') : ids[0]
            });
        }

        // Добавляем фильтры по датам
        dateFilter('deliveryDate', mergedFilters, filtersArray);
        dateFilter('departureDate', mergedFilters, filtersArray);
        dateFilter('createdDate', mergedFilters, filtersArray);

        return {
            filters: filtersArray.length > 0 ? filtersArray : null,
            order: order || urlState.order || null
        };
    }, [getMergedFiltersForRequest, getMergedSearchForRequest, order, urlState.order]);

    const loadPage = useCallback(() => {
        // Проверяем, что компонент еще смонтирован
        if (!isMountedRef.current) {
            return;
        }
        
        // Отменяем предыдущий запрос, если он есть
        if (searchAbortControllerRef.current) {
            searchAbortControllerRef.current.abort();
        }
        
        // Создаем новый AbortController для текущего запроса
        const abortController = new AbortController();
        
        searchAbortControllerRef.current = abortController;
        
        if (isMountedRef.current) {
            setLoading(true);
        }
        
        let settings = getSettings();
        const offset = (page - 1) * rowCount;
        
        // Проверяем, есть ли хотя бы один фильтр или поиск
        const hasFilters = settings.filters && settings.filters.length > 0;
        const hasSearch = (urlState.searchId && urlState.searchId.trim().length > 0) || (searchId && searchId.trim().length > 0);
        
        if (!hasFilters && !hasSearch) {
            // Если нет фильтров и поиска, загружаем только первые 50 записей
            settings.filters = null;
        }
        
        // Добавляем сигнал отмены к запросу
        loadData(settings, rowCount, offset, false, abortController.signal)
            .then(rows => {
                // Проверяем, не был ли запрос отменен или компонент размонтирован
                if (abortController.signal.aborted || !isMountedRef.current) {
                    return;
                }
                
                const count = rows && rows.entries ? rows.entries.length : 0;
                const total = rows && rows.totalCount ? rows.totalCount : 0;
                
                if (isMountedRef.current) {
                    setRows(rows && rows.entries ? rows.entries : []);
                    setTotalCount(total);
                    setLoading(false);
                    searchAbortControllerRef.current = null;
                }
            })
            .catch(error => {
                if (error.name === 'AbortError' || !isMountedRef.current) {
                    return;
                }
                console.error('Ошибка загрузки данных:', error);
                
                if (isMountedRef.current) {
                    setLoading(false);
                    searchAbortControllerRef.current = null;
                }
            });
    }, [loadData, getSettings, page, rowCount, searchId, urlState.searchId]);

    const applySettings = () => {
        let settings = getSettings();
        apiPost('grid/settings/' + gridKey, settings);
    }

    useEffect(() => {
        applySettings();
    }, []); // Вызывается только при монтировании

    useEffect(() => {
        onFiltersChange && onFiltersChange();
        // Сбрасываем страницу на 1 при изменении фильтров
        if (page !== 1) {
            setPage(1);
        }
    }, [filters]);

    const updateFilter = (fieldName, filterValue) => {
        setFilters(filters => {
            const newFilters = {
                ...filters,
                [fieldName]: filterValue
            };
            // Сохраняем только пользовательское внутреннее состояние
            saveToLocalStorage(newFilters, order, searchId);
            return newFilters;
        })
    }

    const updateSort = (fieldName) => {
        const oldOrder = (order || {}).fieldName === fieldName ? order.order : null;
        const newOrder = oldOrder === 'desc' ? null : {
                fieldName,
                order: !oldOrder ? 'asc' : 'desc'
            };
        setOrder(newOrder);
        // Сохраняем только пользовательское внутреннее состояние
        saveToLocalStorage(filters, newOrder, searchId);
    }

    const clearUrlParams = () => {
        const params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
        if (!params.filters && !params.order && !params.search) {
            return;
        }
        const newParams = { ...params };
        delete newParams.filters;
        delete newParams.order;
        delete newParams.search;
        const query = qs.stringify(newParams);
        const newUrl = window.location.pathname + (query ? `?${query}` : '');
        window.history.replaceState(null, '', newUrl);
    };

    useEffect(() => {
        if (initialState.clearSearch && setSearchId) {
            setSearchId('');
        }
        // Убираем filters из URL после поглощения massUploadFileId в localStorage,
        // чтобы последующие изменения фильтров не сбрасывались при refresh
        if (initialState.clearUrlAfterMassUpload) {
            clearUrlParams();
        }
    }, []);

    const clearSettings = () => {
        const emptyFilters = {};
        setFilters(emptyFilters);
        setOrder(null);
        setUrlState({ filters: {}, order: null, searchId: '' });
        if (setSearchId) {
            setSearchId('');
        }
        saveToLocalStorage(emptyFilters, null, '');
        clearUrlParams();
    }

    // Сохранение состояния и загрузка данных
    useEffect(() => {
        saveToLocalStorage(filters, order, searchId);
        setSettings(getSettings());
        
        // Добавляем debounce для предотвращения множественных запросов
        const timeoutId = setTimeout(() => {
            loadPage();
        }, 300); // 300ms задержка
        
        return () => clearTimeout(timeoutId);
    }, [filters, order, searchId, page]);

    // Очистка при размонтировании
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
            if (searchAbortControllerRef.current) {
                searchAbortControllerRef.current.abort();
            }
        };
    }, []);

    const mergedFilters = getMergedFiltersForRequest();

    return (<div style={{marginTop: filtersWidth && '82px'}}>
        <FiltersBlock
            filters={filters}
            mergedFilters={mergedFilters}
            updateFilter={updateFilter}
            clearSettings={clearSettings}
            isBusy={isBusy}
            getSafeDateValue={getSafeDateValue}
        />
        <section className='table-block'>
            <TableGrid
                width={isFixed && filtersWidth}
                selectedIds={selectedIds}
                setAll={setAll}
                setSelected={setSelected}
                totalCount={totalCount}
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                columns={columns}
                checkbox={true}
                summaries={summaries}
                disableFilters={disableFilters}
                updateFilter={updateFilter}
                filters={filters}
                rows={rows}
                filtersParams={{
                    deliveryDate: {
                        from: getSafeDateValue(filters.deliveryDateFrom),
                        to: getSafeDateValue(filters.deliveryDateTo)
                    },
                    departureDate: {
                        from: getSafeDateValue(filters.departureDateFrom),
                        to: getSafeDateValue(filters.departureDateTo)
                    }
                }}
                setSort={updateSort}
                sort={order}
                loading={loading}
            />
        </section>
    </div>);
};

export default FiltersAndTable;


// WEBPACK FOOTER //
// ./App/pages/parcels/table/filtersAndTable.jsx